import { notification } from 'antd';
import { BackOffice } from 'utils/http';
const BACKOFFICE_BASE_URL = import.meta.env.VITE_APP_BACKOFFICE_API;
const getAccessToken = () => localStorage.getItem('xstak_studio_token');

export const getInvoiceTransactions = async (params) => {
  try {
    const response = await BackOffice.get(`/v1/invoices/xap/aggregated/transactions`, { params });
    return response;
  } catch (err) {
    notification?.error({
      message: err?.response?.data?.message || 'NETWORK ERROR',
      placement: 'bottomRight',
    });
  }
};

export const getInvoices = async (params) => {
  const url = `/v1/invoices/xap`;
  const response = await BackOffice.get(url, {
    params,
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  });
  return response?.data || [];
};

export const getInvoiceDetails = async (invoiceId, store_id) => {
  const url = `/v1/invoices/xap/${invoiceId}?store_id=${store_id}`;
  const response = await BackOffice.get(url, {
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  });
  return response?.data || [];
};

export const getInvoicesExport = async (params) => {
  const url = `/v1/invoices/xap/export`;
  const response = await BackOffice.get(url, {
    params,
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  });
  return response?.data || [];
};

export const getInvoiceTransactionsExport = async (params) => {
  const url = `/v1/invoices/xap/aggregated/transactions/export`;
  const response = await BackOffice.get(url, {
    params,
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  });
  return response;
};
